const switchRecentReadings = (value) => {
    return dispatch => {
        dispatch({ type: 'SWITCH_RECENT_READINGS', value: value });
    }
}
export { switchRecentReadings }